"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkforceHealthMetrics = void 0;
var WorkforceHealthMetrics;
(function (WorkforceHealthMetrics) {
    WorkforceHealthMetrics["ActiveDays"] = "ActiveDays";
    WorkforceHealthMetrics["ResolvedTasks"] = "ResolvedTasks";
    WorkforceHealthMetrics["MergedPRs"] = "MergedPRs";
    WorkforceHealthMetrics["AveragePRCycleTime"] = "AveragePRCycleTime";
    WorkforceHealthMetrics["AveragePRCodingTime"] = "AveragePRCodingTime";
    WorkforceHealthMetrics["AveragePRPendingReviewTime"] = "AveragePRPendingReviewTime";
    WorkforceHealthMetrics["AveragePRReviewTime"] = "AveragePRReviewTime";
    WorkforceHealthMetrics["AveragePRPendingMergeTime"] = "AveragePRPendingMergeTime";
    WorkforceHealthMetrics["ReviewedPRs"] = "ReviewedPRs";
    WorkforceHealthMetrics["AveragePRSize"] = "AveragePRSize";
    WorkforceHealthMetrics["OpenedPRs"] = "OpenedPRs";
    WorkforceHealthMetrics["ClosedUnmergedPRs"] = "ClosedUnmergedPRs";
    WorkforceHealthMetrics["CompletedHighPriorityTasks"] = "CompletedHighPriorityTasks";
    WorkforceHealthMetrics["LinesOfCode"] = "LinesOfCode";
    WorkforceHealthMetrics["Velocity"] = "Velocity";
    WorkforceHealthMetrics["AveragePRCodingAndReviewTime"] = "AveragePRCodingAndReviewTime";
    WorkforceHealthMetrics["LeadTime"] = "LeadTime";
    WorkforceHealthMetrics["MTTR"] = "MTTR";
    WorkforceHealthMetrics["ResolvedBugs"] = "ResolvedBugs";
    WorkforceHealthMetrics["BugsVelocity"] = "BugsVelocity";
    WorkforceHealthMetrics["AveragePrComments"] = "AveragePrComments";
    WorkforceHealthMetrics["WorkDistributionBugsPercent"] = "WorkDistributionBugsPercent";
})(WorkforceHealthMetrics = exports.WorkforceHealthMetrics || (exports.WorkforceHealthMetrics = {}));
//# sourceMappingURL=daily-dev-stats.js.map